import { createSlice } from "@reduxjs/toolkit";

const skillSlice = createSlice({
  name: "skillDetails",
  initialState: {},
  reducers: {},
});

export const selectUserSkillDetails = (state) => state.personaliseLessons?.skillDetails;
export default skillSlice.reducer;
